// Выбор перевода из объекта вида { ru, kk, en }.
//
// Порядок запасных вариантов важен: для англоязычного гостя первым запасным
// идёт русский только после английского, а казахоязычному ближе русский,
// чем английский.
const FALLBACK_ORDER = {
  ru: ["ru", "en", "kk"],
  kk: ["kk", "ru", "en"], // казахоязычному ближе русский, чем английский
  en: ["en", "ru", "kk"],
};

const chainFor = (lang) => FALLBACK_ORDER[lang] || FALLBACK_ORDER.en;

// Возвращает { value, lang } — не только текст, но и язык, на котором он
// реально оказался. Нужно, чтобы повесить на элемент правильный lang=""
// (см. useLocalized ниже): без него скринридер прочитает запасной текст
// голосом не того языка, а браузер применит к нему чужие переносы.
export const pickWithLang = (obj, lang) => {
  if (!obj) return { value: "", lang };
  if (typeof obj === "string") return { value: obj, lang };

  for (const code of chainFor(lang)) {
    const value = obj[code];
    if (value) return { value, lang: code };
  }
  return { value: "", lang };
};

export const pick = (obj, lang) => pickWithLang(obj, lang).value;

// Пропсы для элемента с локализованным текстом: сам текст плюс lang="",
// который проставляется ТОЛЬКО когда сработал запасной язык.
//
//   const title = localizedProps(tour?.name, lang);
//   <h3 {...title.attrs}>{title.value}</h3>
export const localizedProps = (obj, lang) => {
  const { value, lang: actual } = pickWithLang(obj, lang);
  return {
    value,
    attrs: actual === lang ? {} : { lang: actual },
  };
};
